import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import {
  CustomerDocument,
  CustomerDocumentStatus,
} from '../../../../../hoc/common/documents/types';
import {
  useChangeCustomerDocumentsStatusMutation,
  useDeleteCustomerDocumentMutation,
  useLazyGetCustomerDocumentFileQuery,
  useLazyGetCustomerOrganizationDocumentsStatsQuery,
} from '../../../../../hoc/customers/store/services/customers';
import { deleteIsSuccess } from '../../../../../hoc/common/store/slices/documents/documents';

const useDocument = ({
  customerId,
  documentItem,
}: {
  customerId?: string;
  documentItem: CustomerDocument;
}) => {
  const [subMenuVisible, setSubMenuVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<
    CustomerDocumentStatus | undefined
  >();
  const [deletePopupVisible, setDeletePopupVisible] = useState(false);

  const { activePermissions } = useAppSelector((state) => state.root);

  const [
    changeCustomerDocumentsStatus,
    { isLoading: statusChangeInProgress, isSuccess: statusChangeIsSuccess },
  ] = useChangeCustomerDocumentsStatusMutation();
  const [getStats] = useLazyGetCustomerOrganizationDocumentsStatsQuery();

  const dispatch = useAppDispatch();

  const { search } = useLocation();

  const [
    getCustomerDocumentFile,
    { isLoading, isFetching, isSuccess, isError },
  ] = useLazyGetCustomerDocumentFileQuery();
  const [
    deleteFile,
    {
      isLoading: deleteInProgress,
      isSuccess: deleteSuccess,
      isError: deleteError,
    },
  ] = useDeleteCustomerDocumentMutation();

  const getFile = async () => {
    const response = await getCustomerDocumentFile({
      id: customerId as string,
      documentId: documentItem.id,
    });

    if (response.data) {
      const hiddenElement = document.createElement('a');

      const url = window.URL || window.webkitURL;

      // @ts-ignore
      const blob = url.createObjectURL(response.data);
      hiddenElement.href = blob;
      hiddenElement.target = '_blank';
      hiddenElement.download = documentItem.name;
      hiddenElement.click();
    }
  };

  const onDelete = async () => {
    const response = await deleteFile({
      id: customerId as string,
      documentId: documentItem.id,
    });

    if (response) {
      dispatch(
        deleteIsSuccess({ ids: [documentItem.id], id: documentItem.id }),
      );

      setDeletePopupVisible(false);

      getStats(customerId as string);
    }
  };

  return {
    isSuccess,
    isError,
    deleteSuccess,
    deleteError,
    statusChangeIsSuccess,
    setSubMenuVisible,
    setSelectedStatus,
    activePermissions,
    setDeletePopupVisible,
    onDelete,
    deleteInProgress,
    deletePopupVisible,
    subMenuVisible,
    search,
    statusChangeInProgress,
    changeCustomerDocumentsStatus,
    selectedStatus,
    getFile,
    isLoading,
    isFetching,
  };
};

export default useDocument;
